var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-soon"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":"/dist/images/coming-soon.png","alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.__('Coming soon!')))]),_c('span',[_vm._v(_vm._s(_vm.__('This page is in development and will appear soon.')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }